import React from 'react';
import { AlertCircle } from 'lucide-react';

interface AuthErrorBannerProps {
  error: string | null;
}

export const AuthErrorBanner: React.FC<AuthErrorBannerProps> = ({ error }) => {
  if (!error) return null;

  return (
    <div className="mb-5 p-3.5 rounded-xl bg-red-500/10 border border-red-500/20 flex items-start gap-2.5 text-red-400 text-xs leading-relaxed animate-in fade-in duration-200">
      <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
      <span>{error}</span>
    </div>
  );
};
